import React, { useRef, useState } from 'react'
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material'

import UploadCollection, { UploadCollectionRef } from './UploadCollection'
import { KTSVG } from '../../../../../_metronic/helpers'
import CameraModal from '../modals/cameraModal'

interface CameraUploadProps {
  label?: string
  readonly?: boolean
  customPage?: boolean
  idMenuApp?: number
  azFiles: Array<any>
  onDelete: (azFile: any) => void
  onUpload: (newAzFile: any) => void
}

const CameraUpload = ({
  label,
  readonly,
  customPage,
  idMenuApp,
  azFiles,
  onDelete,
  onUpload,
}: CameraUploadProps) => {
  const [showCamera, setShowCamera] = useState(false)
  const uploadRef = useRef<UploadCollectionRef>(null)

  const handleCameraCapture = (file: File) => {
    if (file) {
      // Simula o drop manual
      uploadRef.current?.handleManualDrop(file)
    }
    setShowCamera(false)
  }

  return (
    <Box component='div' sx={{ width: '100%' }}>
      <Dialog open={showCamera} onClose={() => setShowCamera(false)} maxWidth='md' fullWidth>
        <DialogTitle>
          Capturar Foto
          <Button onClick={() => setShowCamera(false)} sx={{ position: 'absolute', right: 8, top: 8 }}>
            Fechar
          </Button>
        </DialogTitle>
        <DialogContent>
          <CameraModal onCapture={handleCameraCapture} />
        </DialogContent>
      </Dialog>

      <UploadCollection
        ref={uploadRef}
        label={label ?? 'Clique ou arraste arquivos, ou use a câmera'}
        readonly={readonly}
        customPage={customPage}
        idMenuApp={idMenuApp}
        azFiles={azFiles}
        modoCamera={true}
        abrirCamera={() => setShowCamera(true)}
        onDelete={onDelete}
        onUpload={onUpload}
      />
    </Box>
  )
}

export default CameraUpload